/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the Errors component that is the entry point into the react Errors.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Required to make use of JSX functionality
 */
import * as React from 'react';

/**
 * Typings
 */
import { RouteChildrenProps } from 'react-router';

/**
 * Utility used to generate a Hook to allow for the creation of styles using JSS.
 */
import { makeStyles } from '@material-ui/core/styles';

/**
 * Material UI Container component.
 */
import { Container } from '@material-ui/core';

/**
 * Material UI Paper component.
 */
import Paper from '@material-ui/core/Paper';

/**
 * Material UI Typography component.
 */
import Typography from '@material-ui/core/Typography';

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/**
 * The top bar displayed throughout the App.
 */
import AppBar from './components/AppBar';

/*
 * ---------------------------------------------------------------------------------
 * Interfaces / Types
 * ---------------------------------------------------------------------------------
 */

interface IErrorsRouteParams {
    errorCode: string;
}

interface IErrorsProps extends RouteChildrenProps<IErrorsRouteParams> {

}

/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */

const useStyles = makeStyles(theme => ({
    page: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    container: {
        flexGrow: 1
    },
    paper: {
      padding: theme.spacing(3, 2),
      margin: theme.spacing(3, 0)
    },
    '@global': {
        '#root': {
            height: '100%'
        },
        body: {
            height: '100%'
        },
        html: {
            height: '100%'
        }
    }
}));

/*
 * ---------------------------------------------------------------------------------
 * Components
 * ---------------------------------------------------------------------------------
 */

const Errors: React.FunctionComponent<IErrorsProps> = ({
    match
}) => {
    const classes = useStyles();

    if (match == null) {
        return (
            <div>
                error
            </div>
        );
    }

    if (!match.params.errorCode) {
        window.location.href = '/';
    }

    return (
        <>
            <div
                className={classes.page}
            >
                <AppBar
                    title={`CTCAE Error`}
                />
                <Container
                    className={classes.container}
                >
                    <Paper
                        className={classes.paper}
                    >
                        <Typography
                            variant="h1"
                        >
                            {match.params.errorCode}
                        </Typography>
                        <Typography
                            variant="body1"
                        >
                            An error has occurred.
                        </Typography>
                    </Paper>
                </Container>
            </div>
        </>
    )
}

/*
 * ---------------------------------------------------------------------------------
 * Export - Default
 * ---------------------------------------------------------------------------------
 */

export default Errors;


// WEBPACK FOOTER //
// ./src/Errors.tsx